import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import "./Assets/css/vendor.min.css";
import "./Assets/css/style.css";
import "./Assets/css/media.css";
import "./Assets/fonts/font-awesome/css/font-awesome.min.css";

import ProductDetails from "./Component/ProductDetails";
import SearchProductDetails from "./Component/SearchProductDetails";
import ContactUs from "./Component/ContactUs";
import ProductView from "./Component/ProductView";
import AboutUs from "./Component/AboutUs";
import Blog from "./Component/Blog";
import { BASE_HREF } from "./config";

let Home = React.lazy(() => import("./Component/Home"));
function App() {
  return (
    <div className="App">
      <BrowserRouter basename={BASE_HREF}>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <React.Suspense fallback={<>...</>}>
                <Home />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/product-details/:id"
            element={
              <React.Suspense fallback={<>...</>}>
                <ProductDetails />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/search-product-details/:id"
            element={
              <React.Suspense fallback={<>...</>}>
                <SearchProductDetails />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/contact-us/:productFlag/:capName"
            element={
              <React.Suspense fallback={<>...</>}>
                <ContactUs />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/product-view"
            element={
              <React.Suspense fallback={<>...</>}>
                <ProductView />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/about-us"
            element={
              <React.Suspense fallback={<>...</>}>
                <AboutUs />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/blog"
            element={
              <React.Suspense fallback={<>...</>}>
                <Blog />
              </React.Suspense>
            }
          />
        </Routes>
        {/* <BottomInfo /> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
